export function getMaxValue<T>(list: T[], compare: (value: T) => number) {
    return list.reduce((max, curr) => {
        const value = compare(curr);
        return Math.max(value, max);
    }, Number.NEGATIVE_INFINITY);
}
